import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators, FormControl, FormArray} from '@angular/forms';
import { Router, ActivatedRoute, Params, PRIMARY_OUTLET, NavigationEnd } from '@angular/router';
import {HelpersService} from '../../services/helpers.service';
import {ReCaptchaV3Service} from 'ng-recaptcha';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AlertPopComponent} from '../alert-pop/alert-pop.component';
import {UserService} from '../../services/user.service';

import {environment} from '../../../environments/environment';
declare let gtag: (property: string, value: any, configs: any) => {};

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [HelpersService, UserService]
})
export class LoginComponent implements OnInit {
  form: FormGroup;
  public captchaValid: boolean;
  public identity;
  public token;

  constructor(
    private userService: UserService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private helperService: HelpersService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.form = this.fb.group({
      email: ['', [Validators.email, Validators.required]],
      password: ['', [Validators.required]]
    });
    this.captchaValid = false;

    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        gtag('config', environment.googleAnalyticsId, {
          page_path: event.urlAfterRedirects
        });
      }
    });


  }

  openAlert(title, text, action, color, direccion = null): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action,
        color
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (direccion === null) {
        console.log(result);
      } else {
        this.router.navigate([direccion]);
      }
    });

   }

  validateCaptcha() {
    this.recaptchaV3Service.execute('importantAction').subscribe((token) => {
      this.helperService.validarCaptcha(token).subscribe(response => {
        if (response.status) {
          this.captchaValid = true;
        } else {
          // tslint:disable-next-line:max-line-length
          this.openAlert('Atención', 'Recaptcha no puede verificar su identidad, vuelva a cargar la página para intentar de nuevo', 'Cerrar', 'warn');
        }

      }, error => {
        console.log(error);
        this.captchaValid = false;
        // tslint:disable-next-line:max-line-length
        this.openAlert('Atención', 'No se puede verificar su identidad por recaptcha, actualice la página para continuar', 'Cerrar', 'warn');
      });
    });

   }

  ngOnInit() {
    /* VALIDATE SESSION */
    if (this.userService.getToken()) {
      this.userService.check_session().subscribe(response => {
        if (response.status) {
          this.router.navigate(['/home']);
        } else {
          this.userService.destroy_session();
        }
      }, error => {
        console.log(error);
        this.userService.destroy_session();
      });
    }
    /* VALIDATE SESSION */
    this.validateCaptcha();
  }


  onSubmit(formulario) {
    this.userService.loginUser(this.form.value).subscribe(response => {
      if (response.status) {
        this.identity = response.identity;
        this.token = response.token;
        localStorage.setItem('identity', JSON.stringify(this.identity));
        localStorage.setItem('token', this.token);
        this.router.navigate(['/home']);
      } else {
        this.openAlert('Atención', response.message, 'Cerrar', 'warn');
      }
    }, error => {
      console.log(error);
      this.openAlert('Atención', 'No se puede procesar su petición en este momento', 'Cerrar', 'warn');
    });
  }

}
